module.exports = __webpack_public_path__ + "img/linkedin.f43a0b2d.svg";